import React from 'react';
import styles from './index.module.less';
import cn from 'classnames';
import { getCdnUrl } from 'base/utils/trans-path';
import PureVideo from '@base/lib/PureVideo';
import { LazyLoad } from '@base/lib/LazyLoad';

export const BannerVideo = props => {
    const {
        banner,
        width,
        height,
        onClick,
        mode,
        videoProps,
    } = props;

    const trackerChildProps = {
        className: cn(
            styles['media-wrap'],
            { [styles['media-wrap-large']]: mode === 'background' },
            'media-wrap'
        ),
        style: {
            // backgroundColor: banner.bgColor || '#f1f0ed',
            backgroundColor: '#000',
            height: mode === 'background' ? `${height}px` : 'auto',
            paddingBottom: `${(height / (width / 100)).toFixed(4)}%`
        },
        onClick
    };

    if (!banner.videoUrl) {
        return null;
    }
    return !banner.videoUrl ? null : (
        <div {...trackerChildProps}>
            <LazyLoad>
                <PureVideo
                    poster={getCdnUrl(banner.picUrl)}
                    src={[banner.videoUrl, banner.videoBackUpUrl || '']}
                    control={{ opacity: 1 }}
                    {...videoProps}
                    className={'video-wrap'}
                    wrapProps={{
                        'data-t-tar': props['data-t-tar'],
                        'data-t-pos': props['data-t-pos']
                    }}
                />
            </LazyLoad>
        </div>
    );
};